import React from 'react'
import { Splash } from '../components/Splash'
import { useCurrentEvent } from '../hooks/useCurrentEvent'

export function StorePages() {
  useCurrentEvent()

  return <Splash />
}
